import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
  accountEmailVerified: false,
  hasFeedListings: false,
  hasPendingEmailVerification: false,
  activeListings: [],
  inactiveListings: [],
});

const emailVerification = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === DispatchConstants.UPDATE_EMAIL_VERIFICATION) {
    return Object.assign({}, state, payload);
  }
  return state;
};

export default emailVerification;
